export const PerioExamSelector = {
  flow: 'x',
  gap: 'Z',
  padding: 'Z A',
  background: 'inkMid',
  round: 'Z',
  border: '1px solid inkBorder',
  overflow: 'auto',
  align: 'center flex-start',

  SelectorLabel: {
    text: '{{ exams2 | polyglot }}',
    fontSize: 'Y',
    fontWeight: '600',
    color: 'inkMuted',
    textTransform: 'uppercase',
    letterSpacing: 'X',
    whiteSpace: 'nowrap'
  },

  ExamList: {
    flow: 'x',
    gap: 'Y',
    childExtends: {
      tag: 'button',
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      cursor: 'pointer',
      fontSize: 'Y',
      whiteSpace: 'nowrap',
      transition: 'all 0.15s ease'
    },
    $collection: (el, s) => {
      var exams = s.root.perioExams || [
        { id: 1, date: '2026-03-18', label: 'Mar 18, 2026' },
        { id: 2, date: '2025-09-15', label: 'Sep 15, 2025' },
        { id: 3, date: '2025-03-10', label: 'Mar 10, 2025' }
      ]
      var currentId = s.root.currentExamId || (exams[0] && exams[0].id)
      return exams.map(function (exam) {
        var isCurrent = exam.id === currentId
        return {
          text: exam.label,
          fontWeight: isCurrent ? '700' : '400',
          color: isCurrent ? 'inkText' : 'inkMuted',
          background: isCurrent ? 'inkSurface' : 'inkMid',
          borderColor: isCurrent ? 'teal' : 'inkBorder',
          onClick: function () {
            s.root.update({ currentExamId: exam.id })
          }
        }
      })
    }
  }
}
